export function getSlugs(games: any, slugs: string[], favoriteGames: string[]) {
  return Object.values(games)
    .filter((game: any) => slugs.includes(game.slug))
    .sort((currentGame: any, nextGame: any) => {
      if (favoriteGames?.includes(currentGame.slug) && !favoriteGames?.includes(nextGame.slug)) {
        return -1
      }

      return 1
    })
    .map((game: any) => ({ slug: game.slug }))
}
